module.exports = __webpack_public_path__ + "static/media/background5.ea3a672c.jpg";